import { useEffect } from "react";

const SITE_NAME = "株式会社エムアイジャパン";
const BASE_URL = "https://mi-japan.net";

// Find an existing head tag or create it, then set one of its attributes.
const upsert = (selector, element, baseAttrs, attr, value) => {
	let tag = document.head.querySelector(selector);
	if (!tag) {
		tag = document.createElement(element);
		Object.entries(baseAttrs).forEach(([k, v]) => tag.setAttribute(k, v));
		document.head.appendChild(tag);
	}
	tag.setAttribute(attr, value);
};

/**
 * Sets per-page <title>, meta description, Open Graph title/description and
 * canonical URL for this single-page app. Crawlers that execute JS pick these
 * up so each route gets its own search-result snippet.
 */
const usePageMeta = ({ title, description, path = "" }) => {
	useEffect(() => {
		const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
		document.title = fullTitle;

		upsert('meta[property="og:title"]', "meta", { property: "og:title" }, "content", fullTitle);
		upsert('link[rel="canonical"]', "link", { rel: "canonical" }, "href", `${BASE_URL}${path}`);

		if (description) {
			upsert('meta[name="description"]', "meta", { name: "description" }, "content", description);
			upsert('meta[property="og:description"]', "meta", { property: "og:description" }, "content", description);
		}
	}, [title, description, path]);
};

export default usePageMeta;
